import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const BD60 = () => (
  <ArticleWrapper articleId="bd60">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <h1 className="text-3xl font-bold text-white mb-6 text-center drop-shadow">BD60</h1>
      <img src="/pictures/gallery/gallery1.JPG" alt="BD60" className="rounded-lg mb-6 mx-auto" />
      <p className="text-gray-200 mb-6 text-center max-w-2xl">
        The BD60 is a compact 60% custom mechanical keyboard designed for enthusiasts who value both form and function. With a robust aluminum case, flexible mounting options, and support for a wide range of keycap sets, the BD60 is a versatile choice for any desk setup.
      </p>
      <h2 className="text-2xl font-semibold text-white mt-8 mb-2 text-center">Key Features</h2>
      <ul className="text-gray-200 mb-8 list-disc list-inside max-w-xl mx-auto">
        <li>60% layout with standard ANSI support</li>
        <li>CNC aluminum case, available in multiple colors</li>
        <li>Hot-swap PCB for easy switch changes</li>
        <li>South-facing RGB backlighting</li>
        <li>QMK/VIA compatibility</li>
        <li>Multiple mounting styles: tray, top, and gummy O-ring</li>
      </ul>
      <h2 className="text-2xl font-semibold text-white mt-8 mb-2 text-center">Sound Test</h2>
      <audio controls className="w-full max-w-xl mb-4">
        <source src="/audio/bd60_mx2a.mp3" type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>
      <p className="text-gray-200 mt-4 text-center max-w-2xl">
        For a full build guide and more sound tests, check out the AEYKBDS YouTube channel.
      </p>
    </div>
  </ArticleWrapper>
);

export default BD60;
